export const cdgiHighlights = [
  "NAAC A+ Accreditation & AICTE Approved Institution",
  "Modern Curriculum with Emerging Tech Integration",
  "Specializations in AI, Data Science, Cybersecurity, Cloud Computing",
  "100+ Top Recruiters including Infosys, TCS, Capgemini, Wipro",
  "Internships, Industrial Visits & Live Projects",
  "Research-Focused Labs & Innovation Cells",
  "Qualified and Experienced Faculty",
];



export const btechCseProgram = [
  "Programming (C, Java, Python, etc.)",
  "Algorithms and Data Structures",
  "Software Engineering & DevOps",
  "Operating Systems & Networking",
  "Web and Mobile Application Development",
  "Artificial Intelligence and Machine Learning",
  "Cybersecurity and Cloud Computing",
  "Database Management Systems (SQL, MongoDB)",
];

export const artLaboratory = [
  "Programming Labs with real-time project deployment",
  "AI & Data Science Labs with Python, TensorFlow",
  "IoT & Embedded Systems Labs",
  "Cybersecurity & Ethical Hacking Labs",
];

export const subfieldsOfAIAndML = [
  "Natural Language Processing",
  "Deep Learning",
  "Neural Networks",
];

export const subfieldsOfCloudComputingAndDevops = [
  "AWS, Azure, Docker, Kubernetes",
  "CI/CD pipelines",
  "Serverless computing",
];

export const subfieldsOfCybersecurity = [
  "Ethical Hacking",
  "Cryptography & Network Security",
  "Information Assurance",
];

export const subfieldsOfDataScienceAndAnalytics = [
  "Python for Data Science",
  "Big Data (Hadoop, Spark)",
  "Data Visualization (Tableau, Power BI)",
];

export const careerOpportunities = [
  "Software Developer/Engineer",
  "Data Scientist / Analyst",
  "Cloud Solutions Architect",
  "Cybersecurity Specialist",
  "AI/ML Engineer",
  "Web & App Developer",
];

export const campusLife = [
  "Coding & Innovation Clubs",
  "Technical Fests & Hackathons",
  "Cultural & Sports Activities",
  "Student Mentorship Programs",
  "Hostel with Wi-Fi, Study Rooms, and Cafeterias",
];

export const learningApproach = [
  "Project-Based Learning",
  "Collaborative Research",
  "Academic Counseling & Industry Networking",
];

export const researchAndInnovation = [
  "Final Year Projects with Industry Mentorship",
  "Startup Incubation Support",
  "Research Paper Publication & Patent Filing",
  "Funding Opportunities through AICTE/MSME",
];

export const cdgiFAQs = [
  {
    index: 1,
    question: "Is CDGI a good college for computer science engineering?",
    answer: "Yes. CDGI is consistently ranked among the top engineering colleges for computer science engineering in MP."
  },
  {
    index: 2,
    question: "What specializations are available in the CSE program?",
    answer: "Students can specialize in AI, Data Science, Cybersecurity, Cloud Computing, and more."
  },
  {
    index: 3,
    question: "What are the placement opportunities for CSE students at CDGI?",
    answer: "Over 100 top companies recruit CSE graduates every year with roles in development, analytics, and security."
  },
  {
    index: 4,
    question: "Are internships offered?",
    answer: "Yes. CDGI has internship tie-ups with tech startups and corporates for real-world exposure."
  },
  {
    index: 5,
    question: "How can I apply for the CSE program?",
    answer: "You can apply online through our official website: www.cdgi.edu.in"
  }
];
